import noop from 'utils/noop';
import { Radio, RadioProps } from './Radio';
import { TileRadioWrapper, RadioIcon } from './TileRadio.styled';

export enum RADIO_VARIANTS {
  VERTICAL = 'vertical',
  DEFAULT = 'default',
}

type TileRadioProps = RadioProps & {
  children?: React.ReactNode;
  className?: string;
  variant?: RADIO_VARIANTS;
};

export const TileRadio = ({
  isDisabled = false,
  onClick,
  children,
  variant = RADIO_VARIANTS.DEFAULT,
  className,
  ...props
}: TileRadioProps) => {
  const isVertical = variant === RADIO_VARIANTS.VERTICAL;
  return (
    <TileRadioWrapper
      isDisabled={isDisabled}
      onClick={isDisabled ? noop : onClick}
      isVertical={isVertical}
      className={className}
      {...props}
    >
      <RadioIcon isVertical={isVertical}>
        <Radio isDisabled={isDisabled} onClick={isDisabled ? noop : onClick} {...props} />
      </RadioIcon>
      {children}
    </TileRadioWrapper>
  );
};
